import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container } from 'reactstrap';
import './login.css';
import APIRequest from '../../helpers/APIRequest';


class Activation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activate: 'running'
    };
  }

  componentWillMount () {
    console.log('componentWillMount', this.props.userId);
    APIRequest.post(`users/${this.props.userId}/activation/${this.props.activationKey}`).then(res => {
      this.setState({activate: 'sucess'});
    }).catch(error => this.setState({activate: 'failed', message: error.message}));
  }

  render () {

    return (
      <div className="login-page bg-dark">

        <div className="login-wrapper">

          <div className="login-wrapper-inner">
            <Container>

              <div className="login-box">
                {this.state.activate === 'running' ?
                  <p className="alert alert-info mb-0">Activation in progress...</p>
                : null}

                {this.state.activate === 'failed' ?
                  <div className="alert alert-danger mb-0">
                    <p>Activation failed...</p>
                    <p>{this.state.message}</p>
                  </div>

                : null}
                {this.state.activate === 'sucess' ?
                  <div className="alert alert-success mb-0">
                    <p>Activation succeeded !</p>
                  </div>
                : null }
              </div>
            </Container>
          </div>
        </div>
      </div>
    )
  }
}

Activation.propTypes = {
}

// These props come from the application's
// state when it is started
const mapStateToProps = (state, ownProps) => ({
  ...ownProps.match.params
})

export default connect(mapStateToProps)(Activation)



// WEBPACK FOOTER //
// ./src/containers/login/activation.js